/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, file } from '@gh/core-data';
import { ImportLeadsBatchIdDto, ImportLeadsTemplateDto } from './import-leads.dto';

export const ImportLeadsFileMapper = file();
export const ImportLeadsBatchIdMapper = entity<ImportLeadsBatchIdDto>({});
export const ImportLeadsTemplateMapper = entity<ImportLeadsTemplateDto>({});
